<template>
  <div class="drawer-detail">
    <div class="field-type">
      <span class="label">
        职位话术:
        <el-tooltip :disabled="!project['可能的问题及应对']||project['可能的问题及应对'].length===0" :visible-arrow="false" popper-class="alpha-color-ccc" effect="light" placement="left">
          <div slot="content" class="qanda" style="max-height:300px;width:300px;overflow:auto;">
            <div v-for="(obj,ind) in project['可能的问题及应对']" :key="`QA${ind}`" class="field-type">
              <pre class="value project-pre" style="white-space:pre-wrap;">Q:{{obj.Q}}
A:{{obj.A}}</pre>
            </div>
          </div>
          <span :class="!project['可能的问题及应对']||project['可能的问题及应对'].length===0?'shallow-gray-text':'link-text'"><i class="el-icon-view mr10"></i>可能的问题及应对</span>
        </el-tooltip>
      </span>
      <div :class="[project['职位话术']?'':'gray-text','value project-pre']">
        <p v-if="project['职位话术']">{{project['职位话术']}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('职位话术')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <div class="search-row">
      <span class="label">部门名称:</span>
      <span class="value"> {{ project['部门'] || '--' }}</span>
    </div>
    <div class="search-row">
      <span class="label">岗位名称:</span>
      <span class="value"> {{ project['项目名称'] || '--' }}</span>
    </div>
    <div class="search-row">
      <span class="label">工作地点:</span>
      <span class="value"> {{ project['地域'] && project['地域'].join('、') || '--' }}</span>
    </div>
    <div class="field-type">
      <span class="label">岗位描述和岗位要求:</span>
      <div :class="[project['岗位描述和岗位要求']?'':'gray-text','value project-pre']">
        <p v-if="project['岗位描述和岗位要求']">{{project['岗位描述和岗位要求']}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('岗位描述和岗位要求')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <div class="field-type">
      <span class="label">
        岗位薪酬:
        <span class="svg-text-btn" type="text" @click="viewSalary">
          <svg t="1621844337690" fill="#409EFF" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11003" width="12" height="12"><path d="M490.666667 117.333333a32 32 0 0 1 3.072 63.850667L490.666667 181.333333H192a10.666667 10.666667 0 0 0-10.496 8.746667L181.333333 192v640a10.666667 10.666667 0 0 0 8.746667 10.496L192 842.666667h640a10.666667 10.666667 0 0 0 10.496-8.746667L842.666667 832V533.333333a32 32 0 0 1 63.850666-3.072L906.666667 533.333333v298.666667a74.666667 74.666667 0 0 1-70.570667 74.56L832 906.666667H192a74.666667 74.666667 0 0 1-74.56-70.570667L117.333333 832V192a74.666667 74.666667 0 0 1 70.570667-74.56L192 117.333333h298.666667z m341.333333 0a74.666667 74.666667 0 0 1 74.56 70.570667L906.666667 192v128a32 32 0 0 1-63.850667 3.072L842.666667 320v-77.226667A781.781333 781.781333 0 0 0 455.168 627.2a32 32 0 1 1-58.112-26.816A845.738667 845.738667 0 0 1 823.296 181.333333H704a32 32 0 0 1-3.072-63.850666L704 117.333333h128z" p-id="11004"></path></svg>
          行业薪酬
        </span>
      </span>
      <div class="mb10" style="display: flex;justify-content: space-around;">
        <span>固薪：{{guxin}}</span>
        <span>全薪：{{quanxin}}</span>
      </div>
      <div :class="[project['岗位薪酬备注']?'':'gray-text','value project-pre']">
        <p v-if="project['岗位薪酬备注']">{{project['岗位薪酬备注']}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('岗位薪酬备注')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <MarketMoney ref="MarketMoney"></MarketMoney>
  </div>
</template>
<script>
import MarketMoney from '../../../../../radish/src/components/market-money'

export default {
  components:{ MarketMoney },
  props: {
    project: { type: Object, default: () => ({}) },
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['一句话简介', '公司优势','公司劣势', '优势业务', '业务特点/风格/资源来源', '人员风格'],
      tagFields:['公司优势','公司劣势','业务特点/风格/资源来源'],
      translateTag: {
        一句话简介: '一句话介绍',
        公司优势: '公司亮点',
        '业务特点/风格/资源来源': '业务特点',
      },
      translate: {
        A: 'A-极度市场化',
        B: 'B-较市场化',
        C: 'C-大平台、合理激励',
        D: 'D-偏向国企风格，较保守',
        E: 'E-大国企、保守',
        F: '团队作战，精英模式',
      },
    }
  },
  computed: {
    guxin() {
      if (this.project.最低固薪 && this.project.最高固薪) {
        return `${this.project.最低固薪}万-${this.project.最高固薪}万`
      } else if (this.project.最低固薪) {
        return `${this.project.最低固薪}万`
      } else if (this.project.最低固薪) {
        return `${this.project.最高固薪}万`
      } else {
        return ''
      }
    },
    quanxin() {
      if (this.project.最低全薪 && this.project.最高全薪) {
        return `${this.project.最低全薪}万-${this.project.最高全薪}万`
      } else if (this.project.最低全薪) {
        return `${this.project.最低全薪}万`
      } else if (this.project.最低全薪) {
        return `${this.project.最高全薪}万`
      } else {
        return ''
      }
    },
  },
  methods: {
    viewSalary() {
      if ((this.project.行业 || this.company.行业) && this.project.职能模块) {
        this.loadSalary()
      } else {
        this.$message('请先填写职能模块、行业')
      }
    },
    loadSalary() {
      this.$refs.MarketMoney.open({
        行业: this.project.行业 || this.company.行业,
        职能模块: this.project.职能模块,
        细分职能:this.project.细分职能,
        擅长方向:this.project.擅长方向,
        职级:this.project.职级,
      })
    },
    quickEdit(field){
      const { translateTag, project } = this
      this.$emit('quickEdit',{
        value: project[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          try {
            await app.service('project').modify({ id: this.project._id, param:{ [field]: v } })
            this.$message.success(`修改成功`)
            this.$set(this.project,field,v)
          } catch (error) {
            this.$message.error(`modify:${error.message}`)
          }
        },
      })
    },
  },
}
</script>
<style>
.alpha-color-ccc{
  border-color:#CCCCCC!important;
  box-shadow: 0 0 5px 0px #d0d0d0;
}
</style>
<style scoped>
.flex {
  display: flex;
}
.cognize-box{
  display: flex;
  flex-wrap:wrap;
}
.cognize-box span{
  display: inline-block;
  min-width: 50%;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
.qanda .field-type .value::after,
pre.notriangle.value::after {
  border-bottom-color: transparent;
}
.svg-text-btn{
  cursor: pointer;
  color: #409eff;
  display: inline-flex;
  align-items: center;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
